import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormType } from '../../backend/openapi/api-types';
import { AnonymousForm } from './anonoymous-form';

export const NewUserForNewCustomerForm: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AnonymousForm
      permissionToContact
      documentTitle={t('form.createNewUserForNewCustomer.documentTitle')}
      formType={FormType.createNewUserForNewCustomer}
    />
  );
};
